export default {
  projectLawsuits: [],
  selectedLawsuit: {}
}
